<template>
    <div class="page bg-gray page-flex">
        <backTitleBar></backTitleBar>
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div v-for="(item,$index) in data" :key="$index" class="list-item ">
                    <div class="flex-center pb-20 bd-bot">
                        <div class="flex1 fs-30 color-333 font-bold flex-center">
<!--                            {{item.itemName}}-->
<!--                            <div class="label">RFID柜</div>-->

                            <span v-if="item.exceptType == 2">订单号：{{item.itemName}}</span>
                            <span v-else>{{item.itemName}}</span>
                        </div>

                        <div class="info-btn click" v-if="item.status == 0" @click="handleConfirm(item)">确认</div>
                        <div class="fs-28 color-main ml-20" v-else>
                            已确认
                        </div>
                    </div>
                    <div class="mt-20 flex-center">
                        <div class="item-img"><img :src="img[item.exceptType]" alt=""></div>
                        <div class="flex1">
                            <div class="fs-32 color-333">{{listDict[item.exceptType].name}}</div>
                            <div class="fs-26 color-999">{{item.createTime}}</div>
                        </div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {confirmWarning} from "@/api/shop"
    export default {
        name: "errorWarning",
        mixins: [initData],
        components:{backTitleBar},
        data(){
            return{
                listDict: [
                    {name:'库存异常',value:'0'},
                    {name:'设备异常',value:'1'},
                    {name:'订单异常',value:'2'},
                ],
                img:[
                    require("../../assets/images/warning/ww0.png"),
                    require("../../assets/images/warning/ww1.png"),
                    require("../../assets/images/warning/ww2.png")
                ],
            }
        },
        methods:{
            beforeInit() {
                this.params = { page : this.page, limit: this.limit};
                this.url = 'statistic/exceptionStatistic/queryExceptionPage';
                return true
            },
            //确认异常
            handleConfirm(item){
                let _this = this;
                this.$dialog.alert({
                    message: "确定此操作？",
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        let params = {
                            exceptType: item.exceptType,
                            exceptionId: item.exceptionId
                        }
                        confirmWarning(params).then(res=>{
                            if(res.code == 0){
                                this.$toast("操作成功");
                                _this.handleQuery()
                            }

                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            }
        },
    }
</script>

<style scoped lang="scss">
    .list-item{
        margin: .2rem .24rem;
        background: #fff;
        border-radius: .12rem;
        overflow: hidden;
        padding: .2rem .24rem;
        .label{
            padding: 0 .1rem;
            height: .4rem;
            line-height: .4rem;
            margin-left: .1rem;
            border: 1px solid rgba(131,194,33,.5);
            color: $main-color;
            font-size: .26rem;
            font-weight: bold;
            border-radius: .06rem;
        }
    }
    .item-img{
        width: 1.14rem;
        height: 1.14rem;
        margin-right: .2rem;
    }
    .info-btn{
        width: 1.04rem;
        height: .54rem;
        border: .01rem solid $org;
        text-align: center;
        line-height: .52rem;
        border-radius: .12rem;
        font-size: .28rem;
        color: $org;
    }
</style>



// WEBPACK FOOTER //
// errorWarning.vue?738637d8